// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__vXf4A","topBottomGutter":"Layout_topBottomGutter__2tW0e"};